/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Rehab_Ex_ThreeInputs */

const en_for_whom_rehab_ex_three = /** @type {(inputs: For_Whom_Rehab_Ex_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supported split squat`)
};

const pl_for_whom_rehab_ex_three = /** @type {(inputs: For_Whom_Rehab_Ex_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wykrok z podparciem`)
};

/**
* | output |
* | --- |
* | "Supported split squat" |
*
* @param {For_Whom_Rehab_Ex_ThreeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_rehab_ex_three = /** @type {((inputs?: For_Whom_Rehab_Ex_ThreeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Rehab_Ex_ThreeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_rehab_ex_three(inputs)
	return en_for_whom_rehab_ex_three(inputs)
});